export default __webpack_public_path__ + "static/media/emailSent.73166215.svg";